import {
  MyApprovalsIcon,
  NeedOffersIcon,
  OpenPOSIcon,
  ReadyForPOIcon,
  SkuResolutionIcon,
  StuckIcon,
} from 'assets/icons/ProcurementDashboard'
import { Flex } from 'styling/GlobalStyles'
import { ColorVariant, Heading1, SmallText, TinyText } from 'styling/TypographyV2'
import { tokens } from 'styling/tokens'
import { ProcurementDashboardCountsResponse } from 'types/procurement'
import { CountContainer, IconContainer, ItemContainer } from './DashboardCount.styles'

type TItem = {
  icon: React.ReactNode
  title: string
  description: string
  count: number
  color: string
}

export const DashboardCount = ({ counts }: { counts?: ProcurementDashboardCountsResponse }) => {
  const items: TItem[] = [
    {
      icon: <MyApprovalsIcon />,
      title: 'My Approvals',
      description: 'Waiting for action',
      count: counts?.myApprovalsCount || 0,
      color: tokens.status.warning.fg,
    },
    {
      icon: <NeedOffersIcon />,
      title: 'Need Offers',
      description: 'In sourcing',
      count: counts?.needOffersCount || 0,
      color: tokens.status.info.fg,
    },
    {
      icon: <SkuResolutionIcon />,
      title: 'Sku Resolution',
      description: 'Free text pending',
      count: counts?.skuResolutionCount || 0,
      color: tokens.accent.base,
    },
    {
      icon: <ReadyForPOIcon />,
      title: 'Ready for PO',
      description: 'Fully approved',
      count: counts?.readyForPoCount || 0,
      color: tokens.status.success.fg,
    },
    {
      icon: <OpenPOSIcon />,
      title: 'Open POs',
      description: 'Waiting receipts',
      count: counts?.openPurchaseOrdersCount || 0,
      color: tokens.status.info.fg,
    },
    {
      icon: <StuckIcon />,
      title: 'STUCK > 7',
      description: 'Needs attention',
      count: counts?.stuckedPurchaseOrdersCount || 0,
      color: tokens.status.danger.fg,
    },
  ]

  return (
    <CountContainer>
      {items.map((item) => (
        <Item key={item.title} item={item} />
      ))}
    </CountContainer>
  )
}

const Item = ({ item }: { item: TItem }) => {
  return (
    <ItemContainer hexColor={item.color}>
      <IconContainer hexColor={item.color}>{item.icon}</IconContainer>
      <Flex column gap='4px'>
        <Heading1>{item.count}</Heading1>
        <SmallText colorVariant={ColorVariant.SECONDARY} uppercase bold>
          {item.title}
        </SmallText>
        <TinyText colorVariant={ColorVariant.FADED}>{item.description}</TinyText>
      </Flex>
    </ItemContainer>
  )
}
